import React from "react";
import { connect } from "react-redux";
import ShipCard from "./ShipCard";
import { Trans, withTranslation } from "react-i18next";
import { Button, Popover, PopoverHeader, PopoverBody } from "reactstrap";
import { Translation } from "react-i18next";
import {
  getClientShipCount,
  getClientShipDetails,
  getClientSearchlist,
} from "../Actions/ClientDashboardAPI";
import DatePicker from "react-datepicker";
import Moment from "moment";
import "react-datepicker/dist/react-datepicker.css";
import { AutoComplete } from "primereact/autocomplete";
import FileSaver from "file-saver";
import "primereact/resources/themes/nova-light/theme.css";
import "primereact/resources/primereact.css";
import CountUp from "react-countup";
import { getShipSearchlist } from "../Actions/MMPLDashboardAPI";
import { Multiselect } from "multiselect-react-dropdown";
import { getServiceTypeList } from "../Actions/CommonAPI";
import MapCharts from "./Mapchart";
import $ from "jquery";
import axios from "axios";
import API from "../helpers/api";

const SearchItem = {
  IsClient: true,
  shipName: "",
  nextServiceDateFrom: "",
  nextServiceDateTo: "",
  ServiceTypes: [],
  client: "",
  category: "",
  imoNo: "",
  status: "active",
  pagenumber: 1,
  pagesize: 25,
  isTotalShips: true,
  isOverdueShips: false,
  isShipsDue10: false,
  isShipsDue30: false,
  isShipsDue60: false,
  isShipsDue90: false,
};

class ClientDashboardLibrary extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      allShipo: 100,
      expiredShips: 100,
      expiringShips: 90,
      fromDatePickerIsOpen: false,
      toDatePickerIsOpen: false,
      filterTitle: "All Ships",
      SelectedFromDate: "",
      SelectedToDate: "",
      action: 1,
      markers: [],
      searchDate: {
        IsClient: true,
        shipName: "",
        nextServiceDateFrom: "",
        nextServiceDateTo: "",
        ServiceTypes: [],
        client: "",
        category: "",
        imoNo: "",
        pagenumber: 1,
        pagesize: 25,
        noofrecords: 2,
        isTotalShips: true,
        isOverdueShips: false,
        isShipsDue10: false,
        isShipsDue30: false,
        isShipsDue60: false,
        isShipsDue90: false,
        status: "active",
        isShipSearch: false,
        isShoreSearch: false
      },
      inContract: false,
      notInContract: false,
      isBoth: true,
      isPopoveropen: false,
      EquipmentList: ["A_Equipment1", "B_Equipment2", "C_Equipment"],
      PageNo: 1,
      serviceType: [],
    };
    this.onSelectChange = this.onSelectChange.bind(this);
    this.onRemoveChange = this.onRemoveChange.bind(this);
    this.handleFromDateChange = this.handleFromDateChange.bind(this);
    this.handleToDateChange = this.handleToDateChange.bind(this);
    this.openFromDatePicker = this.openFromDatePicker.bind(this);
    this.openToDatePicker = this.openToDatePicker.bind(this);
    this.GenerateReportData = this.GenerateReportData.bind(this);
    this.handleBlur = this.handleBlur.bind(this);
    this.SearchShips = this.SearchShips.bind(this);
    this.ClearSearchField = this.ClearSearchField.bind(this);
  }

  componentDidMount() {
    const { dispatch, searchData, searched } = this.props;
    this.props.dispatch({ type: "ShowShipDetails", data: false });
    let BothResult = localStorage.getItem("SearchBothContract");
    let ContractResult = localStorage.getItem("SearchCotract");
    if (BothResult !== "") {
      this.state.isBoth = JSON.parse(BothResult);
    }
    if (ContractResult === "false" && BothResult !== "true") {
      this.state.inContract = JSON.parse(ContractResult);
      this.state.notInContract = true;
    } else if (ContractResult !== "") {
      this.state.inContract = JSON.parse(ContractResult);
    }

    this.setState({}, () => {
      console.log(this.state.inContract, this.state.notInContract, this.state.isBoth)
    })
    dispatch(getClientShipCount(this.state.inContract, this.state.isBoth));
    if (searchData) {
      this.state.searchDate = searchData;
      this.state.searchDate.status = "active";
      if (searched !== true) {
        this.ClearSearchField("clear");
        dispatch({ type: "searchData", data: "" });
      }
      dispatch({ type: "searched", data: false });
    }
    dispatch(getShipSearchlist(this.state.searchDate, this.state.inContract, this.state.isBoth, true));
    dispatch(getServiceTypeList());
    this.getMapInfo(this.state.inContract, this.state.isBoth);
    let searchitem = this.state.searchDate;
    let _this = this;
    $(document).keypress(function (event) {
      var keycode = event.keyCode || event.which;
      if (
        searchitem.shipName ||
        searchitem.client ||
        searchitem.imoNo ||
        searchitem.ServiceTypes.length > 0 ||
        searchitem.nextServiceDateFrom ||
        searchitem.nextServiceDateTo
      ) {
        if (keycode === 13) {
          _this.SearchShips(1, 2, true);
        }
      }
    });
  }

  static getDerivedStateFromProps(nextProps, prevState) {
    const { dispatch, searchData, } = nextProps;
    if (searchData) {
      prevState.searchDate = searchData;
    }
  }

  getShipDetails(action, isShipSearch = false, isShoreSearch = false) {
    const { dispatch } = this.props;
    if (action === 1) {
      this.state.filterTitle = "All Ships";
      this.state.searchDate.isTotalShips = true;
      this.state.searchDate.isOverdueShips = false;
      this.state.searchDate.isShipsDue30 = false;
      this.state.searchDate.isShipsDue90 = false;
      this.setState(
        {
          action: 1,
          searchDate: this.state.searchDate,
        },
        () => {
          this.SearchShips(1, 2, true);
          this.ClearSearchField("cardClick");
        }
      );
    } else if (action === 2) {
      this.state.filterTitle = "Overdue Ships";
      this.state.searchDate.isTotalShips = false;
      this.state.searchDate.isOverdueShips = true;
      this.state.searchDate.isShipsDue30 = false;
      this.state.searchDate.isShipsDue90 = false;
      this.state.searchDate.isShipSearch = isShipSearch;
      this.state.searchDate.isShoreSearch = isShoreSearch;
      this.setState(
        {
          action: 2,
          searchDate: this.state.searchDate,
        },
        () => {
          this.SearchShips(1, 2, false);
          this.ClearSearchField("cardClick");
        }
      );
    } else if (action === 3) {
      this.state.filterTitle = "Ships Due in 30 Days";
      this.state.searchDate.isTotalShips = false;
      this.state.searchDate.isOverdueShips = false;
      this.state.searchDate.isShipsDue30 = true;
      this.state.searchDate.isShipsDue90 = false;
      this.state.searchDate.isShipSearch = isShipSearch;
      this.state.searchDate.isShoreSearch = isShoreSearch;
      this.setState(
        {
          action: 4,
          searchDate: this.state.searchDate,
        },
        () => {
          this.SearchShips(1, 2, false);
          this.ClearSearchField("cardClick");
        }
      );
    } else if (action === 4) {
      this.state.filterTitle = "Ships Due in 90 Days";
      this.state.searchDate.isTotalShips = false;
      this.state.searchDate.isOverdueShips = false;
      this.state.searchDate.isShipsDue30 = false;
      this.state.searchDate.isShipsDue90 = true;
      this.state.searchDate.isShipSearch = isShipSearch;
      this.state.searchDate.isShoreSearch = isShoreSearch;
      this.setState(
        {
          action: 6,
          searchDate: this.state.searchDate,
        },
        () => {
          this.SearchShips(1, 2, false);
          this.ClearSearchField("cardClick");
        }
      );
    }
    this.getMapInfo(this.state.inContract, this.state.isBoth);
  }

  GenerateReportData(contract, both) {
    let user = JSON.parse(localStorage.getItem("currentUser"));
    let URL = `${API.ShipReportAPI}?IsClient=${this.state.searchDate.IsClient}&status=${this.state.searchDate.status}&Mail=${user.email}&FliterByTotalShips=${this.state.searchDate.isTotalShips}&FliterByOverDue=${this.state.searchDate.isOverdueShips}&MMPLFliterByDueIn10Days=${this.state.searchDate.isShipsDue10}&FliterByDueIn30Days=${this.state.searchDate.isShipsDue30}&MMPLFliterByDueIn60Days=${this.state.searchDate.isShipsDue60}&FliterByDueIn90Days=${this.state.searchDate.isShipsDue90}&ShipName=${this.state.searchDate.shipName}&imo=${this.state.searchDate.imoNo}&MmplClientName=${this.state.searchDate.client}&MmplCategoryName=${this.state.searchDate.category}&ServiceTypes=${this.state.searchDate.ServiceTypes}&NextDueInFromDate=${this.state.searchDate.nextServiceDateFrom}&NextDueInToDate=${this.state.searchDate.nextServiceDateTo}&inContract=${contract}&isBoth=${both}&PageNumber=${this.state.searchDate.pagenumber}&PageSize=${this.state.searchDate.pagesize}`;
    axios
      .get(URL, { responseType: "blob" })
      .then((response) => {
        let blob = "";
        blob = new Blob([response.data], { type: response.data.type });
        FileSaver.saveAs(blob,
          "Ship report" + Moment().format("DD MM YYYY LT") + ".xlsx");
      })
      .catch((error) => {
        console.log(error);
      });
  }

  SearchShips(pgno, noof, totalship) {
    this.state.searchDate["noofrecords"] = noof;
    this.state.searchDate["pagenumber"] = pgno;
    const { dispatch } = this.props;
    dispatch({ type: "searchData", data: this.state.searchDate });
    dispatch(getShipSearchlist(this.state.searchDate, this.state.inContract, this.state.isBoth, totalship));
  }

  ClearSearchField(type) {
    const { dispatch } = this.props;
    this.setState(
      {
        searchDate: {
          IsClient: true,
          shipName: "",
          nextServiceDateFrom: "",
          nextServiceDateTo: "",
          ServiceTypes: [],
          client: "",
          category: "",
          imoNo: "",
          status: "active",
          noofrecords: 2,
          pagenumber: 1,
          pagesize: 25,
          isTotalShips: this.state.searchDate.isTotalShips,
          isOverdueShips: this.state.searchDate.isOverdueShips,
          isShipsDue10: this.state.searchDate.isShipsDue10,
          isShipsDue30: this.state.searchDate.isShipsDue30,
          isShipsDue60: this.state.searchDate.isShipsDue60,
          isShipsDue90: this.state.searchDate.isShipsDue90,
          isShipSearch: this.state.searchDate.isShipSearch,
          isShoreSearch: this.state.searchDate.isShoreSearch,
        },
        serviceType: [],
      },
      () => {
        if (type !== "cardClick") {
          dispatch({ type: "searchData", data: "" });
          dispatch({ type: "searched", data: false });
          dispatch(getShipSearchlist(this.state.searchDate, this.state.inContract, this.state.isBoth, true));
        }
        this.state.serviceType = [];
        this.setState({});
      }
    );
  }
  toggle = (target, item) => {
    this.state.inContract = this.state.inContract;
    this.state.isBoth = this.state.isBoth;
    this.state.notInContract = this.state.notInContract;
    this.state.isPopoveropen = !this.state.isPopoveropen;
    this.setState({});
  };
  handleRadioButtonChange = (e) => {
    let nodeName = e.target.name;
    if (nodeName === "incontract") {
      this.state.inContract = true;
      this.state.notInContract = false;
      this.state.isBoth = false;
    }
    if (nodeName === "notcontract") {
      this.state.inContract = false;
      this.state.notInContract = true;
      this.state.isBoth = false;
    }
    if (nodeName === "both") {
      this.state.inContract = false;
      this.state.notInContract = false;
      this.state.isBoth = true;
    }
    this.setState({});
  };


  submitRequest = () => {
    const { dispatch } = this.props;
    localStorage.setItem("SearchCotract", this.state.inContract)
    localStorage.setItem("SearchBothContract", this.state.isBoth)
    dispatch(getShipSearchlist(this.state.searchDate, this.state.inContract, this.state.isBoth, true));
    dispatch(getClientShipCount(this.state.inContract, this.state.isBoth));
    this.getMapInfo(this.state.inContract, this.state.isBoth)
    this.state.isPopoveropen = !this.state.isPopoveropen;
    this.setState({})

  };

  handleFromDateChange(date) {
    this.state.searchDate.nextServiceDateFrom = Moment(
      new Date(Date.parse(date))
    ).format("YYYY-MM-DD");
    this.setState({
      SelectedFromDate: date,
      fromDatePickerIsOpen: false,
    });
  }

  handleToDateChange(date) {
    this.state.searchDate.nextServiceDateTo = Moment(
      new Date(Date.parse(date))
    ).format("YYYY-MM-DD");
    this.setState({
      SelectedToDate: date,
      toDatePickerIsOpen: false,
    });
  }

  openFromDatePicker() {
    this.setState({
      toDatePickerIsOpen: false,
      fromDatePickerIsOpen: !this.state.fromDatePickerIsOpen,
    });
  }

  openToDatePicker() {
    this.setState({
      fromDatePickerIsOpen: false,
      toDatePickerIsOpen: !this.state.toDatePickerIsOpen,
    });
  }

  handleBlur() {
    this.setState({
      toDatePickerIsOpen: false,
      fromDatePickerIsOpen: false,
    });
  }

  handleInputChange(e) {
    let nodeName = e.target.name;
    this.state.searchDate[nodeName] = e.target.value;
    this.setState({});
  }

  serviceTypeChange(item, e) {
    let checked = [];
    checked = this.state.serviceType;
    if (e.target.checked) {
      checked.push({
        checkboxValue: item,
      });
      if (item === "Annual") {
        this.state.searchDate.Annually = true;
      } else if (item === "Biannual") {
        this.state.searchDate.Biannually = true;
      } else if (item === "Five yearly") {
        this.state.searchDate.FiveYearly = true;
      } else if (item === "Ten yearly") {
        this.state.searchDate.Tenyearly = true;
      }
    } else {
      const index = checked.findIndex((ch) => ch.checkboxValue === item);
      checked.splice(index, 1);
      if (item === "Annual") {
        this.state.searchDate.Annually = false;
      } else if (item === "Biannual") {
        this.state.searchDate.Biannually = false;
      } else if (item === "Five yearly") {
        this.state.searchDate.FiveYearly = false;
      } else if (item === "Ten yearly") {
        this.state.searchDate.Tenyearly = false;
      }
    }
    this.setState({ serviceType: checked });
    this.setState({});
  }

  suggestMItable(event) {
    let results = this.state.EquipmentList.filter((table) => {
      return table.toLowerCase().indexOf(event.query.toLowerCase()) > -1;
    });

    this.setState({ EquipmentList: results });
  }

  onSelectChange(item) {
    this.state.searchDate.ServiceTypes = item;
    this.setState({});
  }

  onRemoveChange(item) {
    this.state.searchDate.ServiceTypes = item;
    this.setState({});
  }

  getMapInfo = (contract, both) => {
    let user = JSON.parse(localStorage.getItem("currentUser"));
    let url = `${API.MapData}?isClient=true&mail=${user.email}&inContract=${contract}&isBoth=${both}`;
    axios
      .get(url)
      .then((response) => {
        this.bindvalues(response.data);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  bindvalues = (data) => {
    const { action } = this.state;
    if (data.length !== 0) {
      let marker = [];
      data.map((item) => {
        if (action === 1) {
          if (item.isOverdue === true) {
            marker.push({
              ...item,
              markerColor: "#FF0000",
            });
          } else if (item.in10Days === true) {
            marker.push({
              ...item,
              markerColor: "#FF5000",
            });
          } else if (item.in30Days === true) {
            marker.push({
              ...item,
              markerColor: "#FF825A",
            });
          } else if (item.in60Days === true) {
            marker.push({
              ...item,
              markerColor: "#FFA500",
            });
          } else if (item.in90Days === true) {
            marker.push({
              ...item,
              markerColor: "#FFE000",
            });
          } else if (
            item.isOverdue === false &&
            item.in10Days === false &&
            item.in30Days === false &&
            item.in60Days === false &&
            item.in90Days === false
          ) {
            marker.push({
              ...item,
              markerColor: "#008800",
            });
          }
        } else if (action === 2 && item.isOverdue === true) {
          marker.push({
            ...item,
            markerColor: "#FF0000",
          });
        } else if (action === 3 && item.in10Days === true) {
          marker.push({
            ...item,
            markerColor: "#FF5000",
          });
        } else if (action === 4 && item.in30Days === true) {
          marker.push({
            ...item,
            markerColor: "#FF825A",
          });
        } else if (action === 5 && item.in60Days === true) {
          marker.push({
            ...item,
            markerColor: "#FFA500",
          });
        } else if (action === 6 && item.in90Days === true) {
          marker.push({
            ...item,
            markerColor: "#FFE000",
          });
        } else {
          if (item.isOverdue === true) {
            marker.push({
              ...item,
              markerColor: "#FF0000",
            });
          } else if (item.in10Days === true) {
            marker.push({
              ...item,
              markerColor: "#FF5000",
            });
          } else if (item.in30Days === true) {
            marker.push({
              ...item,
              markerColor: "#FF825A",
            });
          } else if (item.in60Days === true) {
            marker.push({
              ...item,
              markerColor: "#FFA500",
            });
          } else if (item.in90Days === true) {
            marker.push({
              ...item,
              markerColor: "#FFE000",
            });
          } else if (
            item.isOverdue === false &&
            item.in10Days === false &&
            item.in30Days === false &&
            item.in60Days === false &&
            item.in90Days === false
          ) {
            marker.push({
              ...item,
              markerColor: "#008800",
            });
          }
        }
      });
      if (action === 1) {
        marker = marker;
      } else if (action === 2) {
        marker = marker.filter((x) => x.isOverdue === true);
      } else if (action === 3) {
        marker = marker.filter((x) => x.in10Days === true);
      } else if (action === 4) {
        marker = marker.filter((x) => x.in30Days === true);
      } else if (action === 5) {
        marker = marker.filter((x) => x.in60Days === true);
      } else if (action === 6) {
        marker = marker.filter((x) => x.in90Days === true);
      } else {
        marker = marker;
      }
      this.setState({ markers: marker });
      console.log("Data", this.state.markers);
    } else {
      this.setState({ markers: [] });
    }
  };

  render() {
    const {
      showSidePane,
      clientShipCount,
      mmplShipSearchResult,
      serviceTypeList,
      t,
    } = this.props;
    const { isTotalShips, isOverdueShips, isShipsDue30, isShipsDue90 } =
      this.state.searchDate;
    const { serviceType } = this.state;
    return (
      <div className="full-height pt-3">
        <div className="row">
          <div className="col-lg-3">
            <div
              className={`${isTotalShips ? "active " : ""
                }card card-selector countcard mb2 p-2 text-center`}
              onClick={() => this.getShipDetails(1)}
            >
              <h1>
                <CountUp
                  start={0}
                  end={clientShipCount ? clientShipCount?.total : 0}
                  duration={2.0}
                  separator=","
                />
              </h1>
              <h5>{t("content.totalship")}</h5>
            </div>
          </div>
          <div className="col-lg-3">
            <div
              className={`${isOverdueShips ? "active " : ""
                }card card-selector countcard mb2 p-2 text-center pointer-default`}

            >
              <h3 style={{ color: "rgb(255, 0, 0)" }} className="pointer-cursor" onClick={() => this.getShipDetails(2)}>
                <CountUp
                  start={0}
                  end={clientShipCount.overDueCount?.total ? clientShipCount.overDueCount?.total : 0}
                  duration={2.0}
                  separator=","
                />
              </h3>
              <h5 className="text-center">{t("content.overdueship")}</h5>
              <div className="row mt-2">
                <div className="col-6">
                  <h6 className="text-nowrap pointer-cursor" onClick={() => this.getShipDetails(2, true, false)}>{t("content.ship")}{" "}
                    <span style={{ color: "rgb(255, 0, 0)" }}>
                      <CountUp
                        start={0}
                        end={clientShipCount.overDueCount?.ship ? clientShipCount.overDueCount?.ship : 0}
                        duration={2.0}
                        separator=","
                      />
                    </span>
                  </h6>
                </div>
                <div className="col-6">
                  <h6 className="text-nowrap pointer-cursor" onClick={() => this.getShipDetails(2, false, true)}>{t("content.shore")}{" "}
                    <span style={{ color: "rgb(255, 0, 0)" }}>
                      <CountUp
                        start={0}
                        end={clientShipCount.overDueCount?.shore ? clientShipCount.overDueCount?.shore : 0}
                        duration={2.0}
                        separator=","
                      />
                    </span>
                  </h6>
                </div>
              </div>
            </div>
          </div>
          <div className="col-lg-3">
            <div
              className={`${isShipsDue30 ? "active " : ""
                }card card-selector countcard mb2 p-2 text-center pointer-default`}

            >
              <h3 style={{ color: "rgb(255, 130, 90)" }} className="pointer-cursor" onClick={() => this.getShipDetails(3)}>
                <CountUp
                  start={0}
                  end={clientShipCount.in30DaysCount?.total ? clientShipCount.in30DaysCount?.total : 0}
                  duration={2.0}
                  separator=","
                />
              </h3>
              <h5 className="text-center">{t("content.30dayship")}</h5>
              <div className="row mt-2">
                <div className="col-6">
                  <h6 className="text-nowrap pointer-cursor" onClick={() => this.getShipDetails(3, true, false)}>{t("content.ship")}{" "}
                    <span style={{ color: "rgb(255, 130, 90)" }}>
                      <CountUp
                        start={0}
                        end={clientShipCount.in30DaysCount?.ship ? clientShipCount.in30DaysCount?.ship : 0}
                        duration={2.0}
                        separator=","
                      />
                    </span>
                  </h6>
                </div>
                <div className="col-6">
                  <h6 className="text-nowrap pointer-cursor" onClick={() => this.getShipDetails(3, false, true)}>{t("content.shore")}{" "}
                    <span style={{ color: "rgb(255, 130, 90)" }}>
                      <CountUp
                        start={0}
                        end={clientShipCount.in30DaysCount?.shore ? clientShipCount.in30DaysCount?.shore : 0}
                        duration={2.0}
                        separator=","
                      />
                    </span>
                  </h6>
                </div>
              </div>
            </div>
          </div>
          <div className="col-lg-3">
            <div
              className={`${isShipsDue90 ? "active " : ""
                }card card-selector countcard mb2 p-2 text-center pointer-default`}

            >
              <h3 style={{ color: "rgb(255, 224, 0)" }} className="pointer-cursor" onClick={() => this.getShipDetails(4)}>
                <CountUp
                  start={0}
                  end={clientShipCount.in90DaysCount?.total ? clientShipCount.in90DaysCount?.total : 0}
                  duration={2.0}
                  separator=","
                />
              </h3>
              <h5 className="text-center">{t("content.90dayship")}</h5>
              <div className="row mt-2">
                <div className="col-6">
                  <h6 className="text-nowrap pointer-cursor" onClick={() => this.getShipDetails(4, true, false)}>{t("content.ship")}{" "}
                    <span style={{ color: "rgb(255, 165, 0)" }}>
                      <CountUp
                        start={0}
                        end={clientShipCount.in90DaysCount?.ship ? clientShipCount.in90DaysCount?.ship : 0}
                        duration={2.0}
                        separator=","
                      />
                    </span>
                  </h6>
                </div>
                <div className="col-6">
                  <h6 className="text-nowrap pointer-cursor" onClick={() => this.getShipDetails(4, false, true)}>{t("content.shore")}{" "}
                    <span style={{ color: "rgb(255, 165, 0)" }}>
                      <CountUp
                        start={0}
                        end={clientShipCount.in90DaysCount?.shore ? clientShipCount.in90DaysCount?.shore : 0}
                        duration={2.0}
                        separator=","
                      />
                    </span>
                  </h6>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="row mt-3">
          <div className="col-lg-12">
            <div className="panel-box">
              <div
                className="card MM-card-header"
                style={{ backgroundColor: "white", border: "0px" }}
              >
                <div className="card-body">
                  <h5
                    className="card-title ml-2 mt-2"
                    style={{ color: "092a51" }}
                  >
                    {this.state.filterTitle === "All Ships"
                      ? `${t("content.Allships")}`
                      : this.state.filterTitle === "Overdue Ships"
                        ? `${t("content.overdueship")}`
                        : this.state.filterTitle === "Ships Due in 30 Days"
                          ? `${t("content.30dayship")}`
                          : this.state.filterTitle === "Ships Due in 90 Days"
                            ? `${t("content.90dayship")}`
                            : ""}
                  </h5>
                </div>
              </div>
              <div
                style={{
                  height: "400px",
                  overflow: "auto",
                  position: "relative",
                }}
              >
                <MapCharts markers={this.state.markers} />
              </div>
            </div>
          </div>
        </div>
        <div className="row mt-3">
          <div className="col-lg-12">
            <div className="panel-box">
              <div
                className="card MM-card-header"
                style={{ backgroundColor: "white", border: "0px" }}
              >
                <div className="card-body">
                  <h5
                    className="card-title ml-2 mt-2"
                    style={{ color: "092a51" }}
                  >
                    {this.state.filterTitle === "All Ships"
                      ? `${t("content.Allships")}`
                      : this.state.filterTitle === "Overdue Ships"
                        ? `${t("content.overdueship")}`
                        : this.state.filterTitle === "Ships Due in 30 Days"
                          ? `${t("content.30dayship")}`
                          : this.state.filterTitle === "Ships Due in 90 Days"
                            ? `${t("content.90dayship")}`
                            : ""}
                  </h5>
                </div>
              </div>
              <div className="search-filter-box">
                <div className="row">
                  <div className={showSidePane ? "col-lg-6 " : "col-lg-4"}>
                    <label className="form-label">{t('content.Shipname')}</label>
                    <br></br>
                    <AutoComplete
                      value={this.state.searchDate.shipName}
                      onChange={(e) => this.handleInputChange(e)}
                      suggestions={this.state.EquipmentList}
                      completeMethod={this.suggestMItable.bind(this)}
                      name="shipName"
                      inputClassName="form-control"
                      placeholder={t('content.Shipname')}
                      style={{ display: "block" }}
                      inputStyle={
                        !showSidePane
                          ? { borderColor: "#ced4da", height: "38px" }
                          : {
                            borderColor: "#ced4da",
                            width: "270.75px",
                            height: "38px",
                          }
                      }
                    />
                  </div>
                  <div className={showSidePane ? "col-lg-6 " : "col-lg-4"}>
                    <label className="form-label">{t('content.Servicetype')} </label>
                    {/* <div className="row">
                      <div className={showSidePane ? "row ml-0" : "col-sm-12 flex flexwrap"}>
                        <div className={showSidePane ? "col-sm-6" : ""}>
                          <input type="checkbox" checked={serviceType.length != 0 ? (serviceType.filter(e => e.checkboxValue == 'Annual').length != 0 ? true : false) : false} onChange={this.serviceTypeChange.bind(this, 'Annual')}></input>
                          <span className="ml-1">Annual</span>
                        </div>
                        <div className={showSidePane ? "col-sm-6" : ""}>
                          <input type="checkbox" checked={serviceType.length != 0 ? (serviceType.filter(e => e.checkboxValue == 'Biannual').length != 0 ? true : false) : false} onChange={this.serviceTypeChange.bind(this, 'Biannual')}></input>
                          <span className="ml-1">Biannual</span>
                        </div>
                        <div className={showSidePane ? "col-sm-6" : ""}>
                          <input type="checkbox" checked={serviceType.length != 0 ? (serviceType.filter(e => e.checkboxValue == 'Five yearly').length != 0 ? true : false) : false} onChange={this.serviceTypeChange.bind(this, 'Five yearly')}></input>
                          <span className="ml-1">Five Yearly</span>
                        </div>
                        <div className={showSidePane ? "col-sm-6" : ""}>
                          <input type="checkbox" checked={serviceType.length != 0 ? (serviceType.filter(e => e.checkboxValue == 'Ten yearly').length != 0 ? true : false) : false} onChange={this.serviceTypeChange.bind(this, 'Ten yearly')}></input>
                          <span className="ml-1">Ten Yearly</span>
                        </div>
                      </div>
                    </div> */}
                    <Multiselect
                      options={serviceTypeList ?? []}
                      isObject={false}
                      style={{
                        option: {
                          "margin-right": 0,
                          display: "block",
                          "font-weight": "normal",
                        },
                        chips: { "background-color": "#1a3464" },
                      }}
                      onSelect={(item) => this.onSelectChange(item)}
                      onRemove={(item) => this.onRemoveChange(item)}
                      selectedValues={this.state.searchDate.ServiceTypes}
                      showArrow={true}
                      placeholder={
                        this.state.searchDate.ServiceTypes &&
                          this.state.searchDate.ServiceTypes.length
                          ? ""
                          : `${t('content.Select')}`
                      }
                      closeIcon="cancel"
                    />
                  </div>
                  <div
                    className={
                      showSidePane
                        ? "col-lg-6  col-sm-12 col-xs-12"
                        : "col-lg-4  col-sm-12 col-xs-12"
                    }
                  >
                    {/* <label className="form-label">Next Due In</label>
                    <br></br> */}
                    <div className="row">
                      <div className="col-sm-6">
                        <label className="form-label">{t('content.NextDueFrom')}</label>
                        <div
                          className="input-group add-on date datepicker"
                          data-date-format="yyyy-mm-dd"
                        >
                          <input
                            type="text"
                            value={this.state.searchDate.nextServiceDateFrom}
                            className="form-control date-picker"
                            placeholder={t('content.NextDueFrom')}
                            name="fromDate"
                          ></input>
                          <DatePicker
                            selected={this.state.SelectedFromDate}
                            onChange={this.handleFromDateChange}
                            open={this.state.fromDatePickerIsOpen}
                            onClickOutside={this.handleBlur}
                            showMonthDropdown
                            showYearDropdown
                            dropdownMode="select"
                            popperPlacement="top-end"
                            className="form-control date-picker w-5 hide-date"
                          // maxDate={this.state.SelectedToDate}
                          />
                          <div
                            className="input-group-btn calendar-icon"
                            onClick={this.openFromDatePicker}
                          >
                            <button
                              className="btn btn-default"
                              style={{ height: "100%" }}
                            >
                              <i className="fa fa-calendar mt-1"></i>
                            </button>
                          </div>
                        </div>
                      </div>
                      <div className="col-sm-6  margin">
                        <label className="form-label">{t('content.NextDueTo')}</label>
                        <div
                          className="input-group add-on date datepicker"
                          data-date-format="yyyy-mm-dd"
                        >
                          <input
                            value={this.state.searchDate.nextServiceDateTo}
                            type="text"
                            placeholder={t('content.NextDueTo')}
                            className="form-control date-picker"
                            name="toDate"
                            data-date-format="yyyy-mm-dd"
                          // minDate={this.state.SelectedFromDate}
                          />
                          <DatePicker
                            selected={this.state.SelectedToDate}
                            onChange={this.handleToDateChange}
                            open={this.state.toDatePickerIsOpen}
                            onClickOutside={this.handleBlur}
                            showMonthDropdown
                            showYearDropdown
                            dropdownMode="select"
                            popperPlacement="top-end"
                            className="form-control date-picker w-5 hide-date"
                          />
                          <div
                            className="input-group-btn calendar-icon"
                            onClick={this.openToDatePicker}
                          >
                            <button
                              className="btn btn-default"
                              style={{ height: "100%" }}
                            >
                              <i className="fa fa-calendar mt-1"></i>
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div
                    className={
                      showSidePane ? "col-lg-12 mt-2" : "col-lg-12 mt-2 mb-2"
                    }
                  >
                    <label className="form-label"></label>
                    <br></br>
                    <div
                      className="form-group search-btn-col"
                      style={{ textAlign: "end" }}
                    >
                      {/* <button className="btn btn-primary text-uppercase txtside-btn txtht-btn blue"
                        id="popover">
                        {" "}
                        {t('ShipManagementContent.Contract')}{" "}
                      </button>

                      <Popover
                        className="popover-master"
                        placement="left"
                        trigger="legacy"
                        isOpen={this.state.isPopoveropen}
                        target={"popover"}
                        toggle={() => this.toggle()}>
                        <PopoverHeader>
                          {t("ShipManagementContent.Contract")}{t("content.Search")}
                        </PopoverHeader>
                        <PopoverBody>
                          <div className="row">
                            <div className="col-4 my-1 d-flex">
                              <input
                                type="radio"
                                name="incontract"
                                checked={this.state.inContract}
                                onChange={(e) =>
                                  this.handleRadioButtonChange(e)
                                }
                              />
                              <span className="ml-1">{t("ContractContent.IsContract")}</span>
                            </div>
                            <div className="col-5 my-1 d-flex">
                              <input
                                type="radio"
                                name="notcontract"
                                checked={this.state.notInContract}
                                onChange={(e) =>
                                  this.handleRadioButtonChange(e)
                                }
                              />
                              <span className="ml-1">{t("ContractContent.NotContract")}</span>
                            </div>
                            <div className="col-3 my-1 d-flex">
                              <input
                                type="radio"
                                name="both"
                                checked={this.state.isBoth}
                                onChange={(e) =>
                                  this.handleRadioButtonChange(e)
                                }
                              />
                              <span className="ml-1">{t("ContractContent.All")}</span>
                            </div>
                            <div
                              className="col-12 mt-1"
                              style={{ textAlign: "right" }}
                            >
                              <div className="btn-group">
                                <Button
                                  className="btn btn-primary btn-xs mt-2"
                                  size="sm"
                                  onClick={() => this.submitRequest()}
                                >
                                  {t("Generateservicerequestcontent.Request")}
                                </Button>
                              </div>
                            </div>
                          </div>
                        </PopoverBody>
                      </Popover> */}
                      <button
                        className="btn btn-primary text-uppercase txtside-btn txtht-btn blue ml-3"
                        type="submit"
                        onClick={() => this.GenerateReportData(this.state.inContract, this.state.isBoth)}
                      >
                        {" "}
                        {/* Generate Report */}  {t('content.GenerateReport')}{" "}
                      </button>
                      <button
                        className="btn btn-primary text-uppercase txtside-btn txtht-btn blue ml-3"
                        type="submit"
                        onClick={() => this.SearchShips(1, 2, true)}
                      >
                        {" "}
                        {t('content.Search')}{" "}
                      </button>
                      <button
                        className="btn btn-light text-uppercase txtside-btn txtht-btn ml-3"
                        type="button"
                        onClick={() => this.ClearSearchField("clear")}
                      >
                        {" "}
                        {t('content.Clear')}{" "}
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        {mmplShipSearchResult ? (
          <ShipCard
            arraylist={mmplShipSearchResult}
            pageSize={mmplShipSearchResult.pagination.pageSize}
            totalRecords={
              mmplShipSearchResult.pagination.totalcount ? mmplShipSearchResult.pagination.totalcount : 0}
            setUpdatedState={(value, records) =>
              this.SearchShips(value, records, true)}
            isContract={this.state.inContract}
            isBoth={this.state.isBoth}
          />
        ) : null}
      </div>
    );
  }
}
function mapStateToProps(state) {
  return {
    clientShipCount: state.SidePanReducer.ClientShipCount || {
      total: 0,
      overDue: 0,
      in30Days: 0,
      in90Days: 0,
    },
    searchData: state.SidePanReducer.searchData,
    searched: state.SidePanReducer.searched,
    clientShipDetails: state.SidePanReducer.ClientShipDetails,
    mmplShipSearchResult: state.MMPLDashboardReducer.MMPLShipSearchResult,
    // serviceTypeList: state.SidePanReducer.ServiceTypeList || {},
    serviceTypeList:
      state.MasterScreenReducer.applicableServiceTypeInterval || [],
  };
}
function mapDispatchToProps(dispatch) {
  return {
    dispatch,
  };
}
export default withTranslation()(
  connect(mapStateToProps, mapDispatchToProps)(ClientDashboardLibrary)
);
